import { useFindSupplierById } from '@/api/supplier.api';
import { memo } from 'react';
import { useParams } from 'react-router';
import { Loader } from 'lucide-react';
import ViewSupplierForm from '@/components/suppliers/ViewSupplierForm';

const ViewSupplierFormMemo = memo(ViewSupplierForm);

const ViewSupplierPage = () => {
  const { supplierId = '' } = useParams();

  const {
    data: supplierData,
    isLoading,
    isSuccess,
  } = useFindSupplierById(supplierId);

  return isLoading ? (
    <Loader />
  ) : (
    isSuccess && (
      <ViewSupplierFormMemo
        supplierResponse={supplierData}
        key={`supplier-${supplierData.id}`}
      />
    )
  );
};

export default ViewSupplierPage;
